import React, { useEffect } from "react";
import SponsorsSection from "components/lsfm_sections/sponsor_section.js";

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";

import BottomBar from "components/Navbars/BottomNavbar";
import SpeakersSection from "components/lsfm_sections/speaker_section";
import ProgrammeSection from "components/lsfm_sections/programme_section";
import AboutSection from "components/lsfm_sections/about_section";
import PurchaseSection from "components/lsfm_sections/purchase_section";






export default function Index() {
  useEffect(() => {
    document.title = "LSFM Konference 2025 | Pirmā LSFM konference Latvijā veltīta kaķu veselības aprūpei un veterinārmedicīnai!";
  }, []);
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // delay a bit to ensure React has rendered
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }
  }, []);




  return (
    <>
      <Navbar transparent />
      <BottomBar />
      <main>
        <div id="top-section" className="relative pt-24 lg:pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">

          <div className="container relative mx-auto">
            <div className=" flex flex-wrap items-center">

              <div className="w-full lg:w-6/12 ml-auto mr-auto px-4 order-2 lg:order-1" >
                <div className="px-6">
                  <h1 className="text-warmGray-800 font-semibold text-5xl">
                    Pirmā LSFM konference Latvijā
                  </h1>
                  <p className="mt-4 text-lg text-warmGray-800">
                    Laipni lūgti LSFM (Latvian Society of Feline Medicine) pirmajā konferencē, kas veltīta kaķu veselības aprūpei un veterinārmedicīnai! Šis ir nozīmīgs notikums veterinārārstiem, veterinārajām māsām, studentiem un visiem, kas aizraujas ar kaķu medicīnu!
                  </p>
                  <div className="mt-8">
                    <button
                      onClick={() => {
                        const el = document.getElementById("purchase-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="bg-lsfm-primary-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
                    >
                      Iegādāties biļeti
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-6/12 ml-auto mr-auto px-4 order-1 lg:order-2"  >
                <img
                  alt="..."
                  className="max-w-full opacity-90"
                  src={require('../assets/img/hero_art.png')}
                />
              </div>
            </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 99"
              x="0"
              y="0"
            >
              <polygon
                className="bg-lsfm-primary-100 fill-lsfm-100"
                points="2560 120 2560 0 120 100"
              ></polygon>
            </svg>
          </div>
        </div>

        <section id="why-section" className="pb-40 bg-lsfm-primary-100 py-20">
          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">

              <div className="container mx-auto px-4">
                <div className="items-center  flex flex-wrap">
                  <div className="w-full lg:w-6/12  px-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img
                      alt="..."
                      className="max-w-full max-h-250-px md:max-h-380-px opacity-90"
                      src={require('../assets/img/why_join_art_2.png')}
                    />
                  </div>
                  <div className="w-full lg:w-6/12 ml-auto mr-auto px-4">
                    <div className="md:pr-10">
                      <div className="text-lsfm-primary-100 bg-lsfm-primary-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 my-6 shadow-lg rounded-full ">
                        <i className="fas fa-cat text-xl"></i>
                      </div>
                      <h3 className="text-3xl font-semibold text-warmGray-800">Kāpēc piedalīties?</h3>
                      <ul className="list-none mt-6">
                        <li className="py-2">
                          <div className="flex items-center">
                            <div>
                              <span className="text-lg font-semibold inline-block py-1 uppercase rounded-full text-lsfm-primary-600 bg-lsfm-primary-200 mr-3" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                <i className="fas fa-user-graduate"></i>
                              </span>
                            </div>
                            <div>
                              <h4 className="text-warmGray-700 text-lg">
                                Saņem jaunākās un aktuālākās zināšanas no <span className="font-bold">vadošajiem jomas ekspertiem.</span>
                              </h4>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="flex items-center">
                            <div>
                              <span className="text-lg font-semibold inline-block py-1 px-2 uppercase rounded-full text-lsfm-primary-600 bg-lsfm-primary-200 mr-3">
                                <i className="fas fa-comments"></i>
                              </span>
                            </div>
                            <div>
                              <h4 className="text-warmGray-700 text-lg">
                                Piedalies diskusijās un <span className="font-bold">jautājumu/atbilžu sesijās</span> tiešsaistē, apgūsti praktiskas diagnostikas un ārstēšanas metodes.
                              </h4>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="flex items-center">
                            <div>
                              <span style={{paddingRight: 10, paddingLeft: 10}} className="text-lg font-semibold inline-block py-1  uppercase rounded-full text-lsfm-primary-600 bg-lsfm-primary-200 mr-3">
                                <i className="fas fa-globe-americas"></i>
                              </span>
                            </div>
                            <div>
                              <h4 className="text-warmGray-700 text-lg">
                                Lektori no <span className="font-bold">Latvijas un Eiropas</span>, kuri dziļi ciena un saprot kaķu īpatnības.
                              </h4>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="flex items-center">
                            <div>
                              <span className="text-lg font-semibold inline-block py-1 uppercase rounded-full text-lsfm-primary-600 bg-lsfm-primary-200 mr-3" style={{paddingLeft: 11, paddingRight: 11}}>
                                <i className="fas fa-calendar"></i>
                              </span>
                            </div>
                            <div>
                              <h4 className="text-warmGray-700 text-lg">
                                Lekciju <span className="font-bold">ieraksti pieejami 3 mēnešus</span> pēc katras tiešsaistes dienas — skatieties sev ērtā laikā, arī ja nevarēsiet būt tiešsaistē.
                                
                              </h4>
                            </div>
                          </div>
                        </li>
                        
                        <li className="py-2">
                          <div className="flex items-center">
                            <div>
                              <span className="text-lg font-semibold inline-block py-1 px-3 uppercase rounded-full text-lsfm-primary-600 bg-lsfm-primary-200 mr-3">
                                <i className="fas fa-award"></i>
                              </span>
                            </div>
                            <div>
                              <h4 className="text-warmGray-700 text-lg">
                                Saņem <span className="font-bold">LVB kvalifikācijas paaugstināšanas punktus</span>, kā arī dalības apliecību latviešu un angļu valodā.
                              </h4>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <section className="py-10 bg-lsfm-primary-100 ">
                        <div className="flex flex-wrap justify-start">
                          <button
                            onClick={() => {
                              const el = document.getElementById("purchase-section");
                              if (el) {
                                const yOffset = -80; // adjust this value to control top spacing
                                const y =
                                  el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                                window.scrollTo({ top: y, behavior: "smooth" });
                              }
                            }}
                            className="bg-lsfm-primary-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
                          >
                            Iegādāties biļeti
                          </button>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </section>


        <section className="pb-20 xs:pt-24  relative block bg-lsfm-primary-50 ">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20 "
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-lsfm-light"
                points="0 120, 0 0, 2440 100"
              ></polygon>
            </svg>
          </div>
        </section>

        <section className="pb-20 bg-lsfm-primary-50 ">

          <SponsorsSection />
        </section>

        <section className="relative ">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-lsfm-white"
                points="2560 0 2560 150 0 100"
              ></polygon>
            </svg>
          </div>


        </section>
        <section id="participants-section" className="pb-20 pt-12 bg-lsfm-white ">
          <SpeakersSection />
          <section className="py-10 bg-lsfm-white ">
                  <div className="flex flex-wrap justify-center">
                    <button
                      onClick={() => {
                        const el = document.getElementById("purchase-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="bg-lsfm-primary-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
                    >
                      Iegādāties biļeti
                    </button>
                  </div>
                </section>
        </section>

        <section className="pb-20 xs:pt-24  relative block bg-lsfm-primary-800">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-lsfm-dark"
                points="2560 0 2560 150 0 100"
              ></polygon>
            </svg>
          </div>


        </section>

        <section id="programme-section" className="pb-20 xs:pt-24  relative block bg-lsfm-primary-800">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-lsfm-dark"
                points="2560 0 2560 150 0 100"
              ></polygon>
            </svg>
          </div>
          <ProgrammeSection />

        </section>


        <section id="about-section" className="relative pb-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20 "
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="0 120, 0 0, 2440 100"
              ></polygon>
            </svg>
          </div>
          <AboutSection />

        </section>

        <section className="pt-20 md:pb-48">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-current"
                points="2560 0 2560 120 0 100"
              ></polygon>
            </svg>
          </div>


        </section>



        <section className="pb-20 xs:pt-24  relative block bg-lsfm-primary-800">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-warmGray-800 fill-lsfm-dark"
                points="2560 0 2560 150 0 100"
              ></polygon>
            </svg>
          </div>


        </section>
        <section id="purchase-section" className="relative block pt-0 py-24 bg-lsfm-primary-800">
          <PurchaseSection />
        </section>


      </main>
      <Footer />
    </>
  );
}
